import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-people-of-interest-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-people-of-interest-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationPeopleOfInterestRcConstants } from "./create-application-people-of-interest-rc.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationPeopleOfInterestRcComponent = class CreateApplicationPeopleOfInterestRcComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    recipientSelectService;
    aflaModuleStrategyService;
    appController;
    changeDetectorRefs;
    peopleOfInterestForm;
    transferorFormControlName = CreateApplicationPeopleOfInterestRcConstants.TRANSFEROR_FORM_CONTROL_NAME;
    transfereeFormControlName = CreateApplicationPeopleOfInterestRcConstants.TRANSFEREE_FORM_CONTROL_NAME;
    conveyancerFormControlName = CreateApplicationPeopleOfInterestRcConstants.CONVEYANCER_FORM_CONTROL_NAME;
    transferorDisableFilterBy = true;
    transferorDisableAdd = true;
    transferorDisableEditing = false;
    transferorShowFields = true;
    transferorIsInternal = false;
    transferorGroups = [];
    transferorLabel = CreateApplicationPeopleOfInterestRcConstants.TRANSFEROR_LABEL;
    transfereeDisableFilterBy = true;
    transfereeDisableAdd = true;
    transfereeDisableEditing = false;
    transfereeShowFields = true;
    transfereeIsInternal = false;
    transfereeGroups = [];
    transfereeLabel = CreateApplicationPeopleOfInterestRcConstants.TRANSFEREE_LABEL;
    copyApplicantToTransfereeLabel = CreateApplicationPeopleOfInterestRcConstants.COPY_APPLICANT_TO_TRANSFEREE_LABEL;
    conveyancerDisableFilterBy = true;
    conveyancerDisableAdd = true;
    conveyancerDisableEditing = false;
    conveyancerShowFields = true;
    conveyancerIsInternal = false;
    conveyancerGroups = [];
    conveyancerLabel = CreateApplicationPeopleOfInterestRcConstants.CONVEYANCER_LABEL;
    copyApplicantToTransfereeFormControlName = CreateApplicationPeopleOfInterestRcConstants.COPY_APPLICANT_TO_TRANSFEREE_FORM_CONTROL_NAME;
    constructor(createApplicationService, recipientSelectService, aflaModuleStrategyService, appController, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.recipientSelectService = recipientSelectService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        try {
            if (this.appController.moduleSimulateMode) {
                this.transferorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
                this.transfereeGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
                this.conveyancerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientExternalFilterGroupObjects);
            }
            else {
                this.transferorGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.transferorGroup);
                this.transfereeGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.transfereeGroup);
                this.conveyancerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.conveyancerGroup);
                this.changeDetectorRefs.markForCheck();
            }
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.peopleOfInterestForm = this.aflaModuleStrategyService.form.get("peopleOfInterestForm");
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToTransfereeClicked(event) {
        const transfereeFormControl = this.peopleOfInterestForm.get("transferee");
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        applicant.groups = this.transfereeGroups;
        applicant.groupsStringArray = this.transfereeGroups?.map(group => group.groupName).join();
        if (event.currentTarget.checked) {
            this.peopleOfInterestForm.get(this.transfereeFormControlName).setValue(applicant);
            transfereeFormControl.disable();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(true);
        }
        else {
            transfereeFormControl.enable();
            this.peopleOfInterestForm.get(this.copyApplicantToTransfereeFormControlName).setValue(false);
        }
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientSelectService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationPeopleOfInterestRcComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-people-of-interest-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationPeopleOfInterestRcComponent);
export { CreateApplicationPeopleOfInterestRcComponent };
